import { useDeviceType } from '@braskai/ui-kit';

import { isDesktopChromium } from '@/shared/lib/browser';

// The platform decides eligibility (the extension installs only in desktop Chromium); a narrow window only defers it.
export const useCanShowRecordingExtensionPrompt = () => {
  const { isMobile } = useDeviceType();

  return { isPlatformEligible: isDesktopChromium(), isViewportWide: !isMobile };
};
